<script setup>
import { TooltipRoot } from 'radix-vue'
</script>

<template>
  <TooltipRoot>
    <slot />
  </TooltipRoot>
</template>
